import React, { FC, Fragment } from "react";

import { Accordion } from "@at/design-system-patterns";

import { Title } from "../leasing-modal-shared-styles.styled";

export const LeasingCommissionDisclosureModal: FC = () => {
  const commissionDisclosureData = [
    {
      rowHeading: "What are commissions and how do they work?",
      rowContent:
        "<p>All leasing adverts on Auto Trader are lease deals provided by Autorama UK Limited. Autorama will receive a commission or other benefits from the funder for every completed credit agreement.</p> <p>Autorama’s funder partners pay Autorama a commission for taking care of your vehicle order, which includes everything from organising your credit application to scheduling delivery. Autorama are also available as your first point of contact for any questions or concerns during your entire vehicle contract period.</p> <p><a href='https://help.autotrader.co.uk/hc/en-gb/articles/16865586061725-How-does-Auto-Trader-make-money-from-finance-and-insurance'>Learn more about Auto Trader’s commissions</a></p>",
    },
    {
      rowHeading: "What is a credit broker?",
      rowContent:
        "Credit brokers work with funders to offer finance options to people who have submitted an application. They work with a panel of funders to find you the cheapest monthly lease price. Credit brokers receive a commission for completed finance agreements but this will never influence which funder is chosen as you will always be shown the cheapest monthly price.",
    },
    {
      rowHeading: "Who are Autorama?",
      rowContent:
        "Autorama UK Limited is a wholly owned subsidiary of Auto Trader Limited. They are a credit broker, which means they will find you the best monthly lease price from a panel of funders. ",
    },
  ];
  return (
    <Fragment>
      <Title as="h3">More about commissions</Title>
      <Accordion items={commissionDisclosureData} />
    </Fragment>
  );
};
